var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrosshair = function SvgCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.499 2.321c5.12.26 9.192 4.493 9.192 9.678 0 5.352-4.339 9.691-9.691 9.691S2.31 17.351 2.31 12A9.69 9.69 0 0 1 12 2.309zm.1 4.224a.6.6 0 0 1-1.199 0V3.53a8.49 8.49 0 0 0-7.868 7.87h3.014a.6.6 0 0 1 0 1.199H3.532a8.49 8.49 0 0 0 7.868 7.868v-3.014a.6.6 0 0 1 1.2 0v3.014a8.49 8.49 0 0 0 7.868-7.868h-3.014a.6.6 0 0 1 0-1.2h3.014A8.49 8.49 0 0 0 12.6 3.53z"
  })));
};
export default SvgCrosshair;